'use strict';

import $ from 'jquery';

// Av ngn magisk anledning måste denna importeras, även om den inte anv av denna kod. Har kanske att göra med att det är jQuery och inte 'äkta' modulariserat?
// eslint-disable-next-line no-unused-vars
import dt from 'datatables.net';

// Denna används för DataTables-kolumnernas index 0–n (enum-medlemmarnas värden) i datavektorn *och* tabellen:
// Provar här en metod att få "enum" i JavaScript:
const KolumnEnum = Object.freeze({
	FAKTURANR: 0,
	DATUM: 1,
	VERIFIKAT: 2,
	FORFDAT: 3,
	BELOPP: 4,
	RESTBELOPP: 5,
	NOTERING: 6,
	ISBETALD: 7
});


/*let datatable = */
let initiera = function(dataTableData) {
		
	return $('#_ss-tabellen_kropp').DataTable({

		data: dataTableData,

		ordering: false,
		/*order: [[0, 'asc']],*/

		dom: 't',	/* Se https://datatables.net/reference/option/dom */
		searching: true,
		/* Sätt den initiala filtreringen: */
		/* Kan även göras med API, så här: tabellen.column(5).search('true').draw(); och '' invaliderar filtret. */
		searchCols: [
			null
			, null
			, null
			, null
			, null
			, null
			, null
			, { search: '' }	// Initialt visas betalda.
		],

		language: {
			loadingRecords: 'Laddar...',
			processing: 'Bearbetar...',
			emptyTable: 'Inga fakturor att visa',
			zeroRecords: 'Inga fakturor matchar ditt filter &nbsp; :('	/* Avser endast filtreringsresultatet! */
		},
		paging: false,
		info: false,
		processing: false,
		autoWidth: false,
		deferRender: true,

		// Arghh! Denna sparar, och återställer, även kolumners visibilitet, vilket *inte* funkar så bra ihop med vårt sätt att hantera kst+proj- eller reskfort-kolumnerna med visible: false. Avstängt tills vidare:
		stateSave: false,
		/* Kan invalideras med tabellen.state.clear(); */

		/*stripeClasses: [ 'ss-udda', 'ss-jamn' ],*/

		responsive: false,	/* Extension som vi inte anv f.n. */

		columnDefs: [
			{ name: 'fakturanr', targets: KolumnEnum.FAKTURANR }
			, { name: 'datum', targets: KolumnEnum.DATUM }
			, { name: 'verifikat', targets: KolumnEnum.VERIFIKAT }
			, { name: 'forfdat', targets: KolumnEnum.FORFDAT }

			, { name: 'belopp', targets: KolumnEnum.BELOPP, className: 'hj' }
			, { name: 'restbelopp', targets: KolumnEnum.RESTBELOPP, className: 'hj' }

			, { name: 'notering', targets: KolumnEnum.NOTERING, className: 'nw' }

			// ----- Visas inte:
			, { name: 'isbetald', targets: KolumnEnum.ISBETALD, visible: false }
		]

		//createdRow(row, data, index) {
		//},
	});
};

let ssoKundDatatable = { 
	// Methods:
	initiera
};

export { ssoKundDatatable };
